import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useLoginMutation } from '@/store/api/authApi';
import { useAppDispatch } from '@/hooks/redux';
import { setToken } from '@/store/slices/authSlice';
import toast from 'react-hot-toast';
import { LoginFormData, loginSchema } from '@/utils/validations';
import CustomInput from '@/components/common/CustomInput';
import { Button } from '@/components/ui/button';

function LoginPage() {
  const [login, { isLoading, error }] = useLoginMutation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data: LoginFormData) => {
    try {
      const payload = {
        username: data.email,
        password: data.password,
      };
      const res = await login(payload).unwrap();
      if (res?.accessToken) {
        dispatch(setToken(res.accessToken));
        reset();
        navigate('/', { replace: true });
      }
    } catch (err: any) {
      console.error('Login failed:', err);
      toast.error(err?.data?.message || 'Login failed!');
    } finally {
    }
  };
  return (
    <div className="space-y-6 w-full max-w-[420px]">
      <img src={`/images/logo.png`} alt="" className="max-w-[140px] self-center mx-auto" />
      <div className="w-full px-8 py-14 bg-white rounded-2xl">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
          {/* Username */}
          <CustomInput
            name="email"
            type="email"
            control={control}
            label="Email*"
            labelClassName="text-primary-darkText"
            placeholder="abc@gmail.com"
            autoComplete="email"
          />

          {/* Password */}
          <CustomInput
            name="password"
            control={control}
            label="Password*"
            labelClassName="text-primary-darkText"
            type="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            inputRules={{
              noSpace: true,
              maxLength: 20,
            }}
          />
          <div className="mt-3 w-full flex justify-center">
            <Button
              type="submit"
              className="w-full px-2 py-2 bg-btn-gradient hover:bg-primary-brown1 rounded-md text-base flex justify-center items-center"
              disabled={isLoading}
            >
              {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : 'LOGIN'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default LoginPage;
